export enum ContactsButtonEnum {
  contacts = 'contacts',
  layouts = 'layouts',
  items = 'items'
}
